import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { fetchDeliverPatient } from '../services/patient';

export function useDeliverPatient() {
    const { id } = useParams<{ id: string }>();

    return useQuery({
        queryKey: ['patient', id, 'deliver'],
        queryFn: () => fetchDeliverPatient(id!),
        enabled: id !== undefined,
        staleTime: 0
    });
}
